import { render, staticRenderFns } from "./BDXMatchPendingManagerList.vue?vue&type=template&id=1e992bc1&scoped=true"
import script from "./BDXMatchPendingManagerList.vue?vue&type=script&lang=js"
export * from "./BDXMatchPendingManagerList.vue?vue&type=script&lang=js"
import style0 from "./BDXMatchPendingManagerList.vue?vue&type=style&index=0&id=1e992bc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e992bc1",
  null
  
)

export default component.exports